import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import DatePicker, {registerLocale} from 'react-datepicker'
import surveys_api from "../api/protected/surveys";
import back_arrow from "../assets/backarrow.svg";
import types from "../assets/constants/types";
import info from "../assets/info-icon.png";
import SurveyPointPopup from "./SurveyPointPopup";
import GenericDialog from "./GenericDialog";

const SurveyUpdateDetails = (props) => {

    const navigate = useNavigate()

    const isDemo = props.isDemo
    const isDraft = props.isDraft

    const disabled_date = (surveyDate) => new Date() < surveyDate;
    const [params, setParams] = useSearchParams()

    const survey = props.survey;

    const [surveyPoint, setSurveyPoint] = useState(1);
    const [surveyType, setSurveyType] = useState(1);
    const [surveyExpiry, setSurveyExpiry] = useState(new Date());

    const [showExpiryHover, setShowExpiryHover] = useState(false)
    const confirmationButtons = [{"text":"OK", "id": "1"}];

    const updateSurvey = () => {
        if (isDraft) {
            let body = {
                "team_id": survey.team_id,
                "name": survey.survey_name,
                "expiry_date": Math.trunc(surveyExpiry.getTime()/1000),
                "survey_type": surveyType,
                "survey_point": surveyPoint,
                "participants": props.selectedPeople ?? []
            }

            let response = surveys_api.updateSurvey(survey.id, body);
            response.then(() => props.result(false, true)).catch(() => console.log(body))

        } else {
            let body = {
                "expiry_date": Math.trunc(surveyExpiry.getTime()/1000)
            }

            let response = surveys_api.putSurveyExpiry(survey.id, body);
            response.then(() => props.result(false, true)).catch(() => console.log(body))
        }
    }

    const validateSubmit = () => {
        return (!surveyType || !surveyPoint);
    }

    useEffect(() => {
        if (survey) {
            setSurveyType(survey.survey_type);
            setSurveyPoint(survey.survey_point);
            setSurveyExpiry(new Date(survey.expiry_date * 1000));
        }
    }, [survey]);

    return (
        <>
            <div className="back-link link" onClick={() => props.result(false, true)}>
                <img className={"back-arrow-classname"} src={back_arrow} alt="Back Arrow"/>
            </div>
            <div className="surveys-page-header">
                <div className="surveys-page-title">Edit survey</div>
            </div>
            <div className="survey-form-container">
                <div className="survey-form-title">Survey Details</div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Survey Point</div>
                        <select disabled={!isDraft} onChange={ev => setSurveyPoint(parseInt(ev.target.value))} value={surveyPoint}>
                            {types.point_types && types.point_types.map((surveyPoint, idx) => {
                                return <option value={surveyPoint.id} key={idx}>{surveyPoint.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Survey Type</div>
                        <select disabled={!isDraft} onChange={ev => setSurveyType(parseInt(ev.target.value))} value={surveyType}>
                            {types.survey_types && types.survey_types.map((surveyType, idx) => {
                                return <option value={surveyType.id} key={idx}>{surveyType.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label info-popup">
                            Survey Expiration Date
                            <img src={info} alt="Info"
                                 onMouseOver={() => setShowExpiryHover(true)}
                                 onMouseLeave={() => setShowExpiryHover(false)}
                            />
                            {showExpiryHover ?
                                <div className="dashboard-roi-title-hover" style={{top: 37, left: 151}}>
                                    <div className="dashboard-roi-title-hover-triangle-outer">
                                        <div className="dashboard-roi-title-hover-triangle-inner"/>
                                    </div>
                                    <div className="dashboard-roi-title-hover-text regular">
                                        This is the deadline for survey completion which is included in the survey
                                        invitation emails and reports. We recommend at least a week for completions.
                                        Note: This is for information only and does not prevent later responses.
                                    </div>
                                </div> : null
                            }
                        </div>
                        <DatePicker dateFormat="dd/MM/yyyy" locale="en-gb" filterDate={disabled_date}
                                    selected={surveyExpiry} onChange={(date) => setSurveyExpiry(date)}
                        />
                    </div>
                </div>
                <div className="field-input flexed">
                    <button className={`update-organisation-button link ${validateSubmit() ? "disabled" : ""}`}
                            onClick={() => updateSurvey()} disabled={validateSubmit()}>
                        SAVE SURVEY
                    </button>
                </div>
            </div>
        </>
    )
}

export default SurveyUpdateDetails;